import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateSurveyInfoHeaderComponent } from './create-survey-info-header.component';
import { SurveyUnicornsInfoComponent } from './survey-unicorns-info/survey-unicorns-info.component';
import { SurveyDifficultQuotasInfoComponent } from './survey-difficult-quotas-info/survey-difficult-quotas-info.component';
import { QuotaReviewModalComponent } from './quota-review-modal/quota-review-modal.component';
import { TableModule } from '@purespectrum1/ui/table';
import { ModalModule } from '@purespectrum1/ui/modal';
import { AidaTooltipModule } from '../../../../shared/ui/aida-tooltip/aida-tooltip.module';

@NgModule({
  declarations: [
    CreateSurveyInfoHeaderComponent,
    SurveyUnicornsInfoComponent,
    SurveyDifficultQuotasInfoComponent,
    QuotaReviewModalComponent,
  ],
  imports: [CommonModule, TableModule, ModalModule, AidaTooltipModule],
  exports: [
    CreateSurveyInfoHeaderComponent,
    SurveyUnicornsInfoComponent,
    SurveyDifficultQuotasInfoComponent,
  ],
})
export class CreateSurveyInfoHeaderModule {}
